<script lang="ts" setup>
defineProps<{ title: string, showChevron?: boolean, iconSrc?: string }>()
</script>

<template>
  <div class="header">
    <div
      v-if="iconSrc"
      class="header__icon-container"
    >
      <img
        :src="iconSrc"
        alt=""
        width="12"
      >
    </div>

    <h2 class="header__title">
      {{ title }}
    </h2>

    <div
      v-if="showChevron"
      class="header__icon-container"
    >
      <img
        class="header__chevron"
        src="/icons/chevron-right.svg"
        alt=""
        width="7"
      >
    </div>
  </div>
</template>

<style scoped>
.header {
  font: var(--font-subtitle1);

  display: flex;
  flex-direction: row;
  padding: var(--spacing-s) var(--spacing-m);
  background-color: var(--gray-lighter);
}

.header__icon-container {
  width: var(--spacing-m);
  display: grid;
  place-items: center;
  padding-inline-end: var(--spacing-xs);
}

.header__title {
  padding-inline-end: var(--spacing-xs);
  flex-grow: 1;
  font-size: 1.6rem;
}
</style>
